import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, View } from 'react-native';
import { Divider, Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';
import lodashFilter from 'lodash/filter';

import Image from '../../../Components/Image';
import ListItem from '../../../Components/ListItem';
import useCancellableRequest from '../../../Hooks/useCancellableRequest';
import withController from '../../../Hooks/withController';
import ThemeColor from '../../../Theme/colors';
import ThemeStyle from '../../../Theme/styles';
import { getCategories } from '../../../Helper/RemoteConfig';

const iconSize = 20;

class Cuisines extends React.PureComponent {
  render() {
    const categories = getCategories();
    if (lodashIsEmpty(categories)) {
      return null;
    }
    const result = lodashFilter(categories, (e) => !e.all);
    return (
      <View
        style={[
          ThemeStyle.pageHorizontalSpacing,
          ThemeStyle.spacingTop,
          ThemeStyle.pageBottomSpacer,
        ]}
      >
        <Text category="s1">Cuisines</Text>
        {result.map((item, index) => (
          <Fragment key={index}>
            <ListItem
              testID={`cuisineButton${index}`}
              accessoryLeft={
                <Image
                  source={{ uri: item.inactive }}
                  style={[
                    { width: iconSize * 1.5, height: iconSize * 1.5 },
                    ThemeStyle.spacingRightMedium,
                  ]}
                />
              }
              rightIcon={{
                color: ThemeColor.darkGray,
                name: 'arrow-ios-forward',
                size: iconSize,
              }}
              contentContainerStyle={ThemeStyle.pageVerticalSpacingMedium}
              title={item.name}
              onPress={() => this.props.onPress(item.name, true)}
            />
            {index !== result.length - 1 && (
              <Divider style={ThemeStyle.divider} />
            )}
          </Fragment>
        ))}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  icon: {
    width: iconSize,
    height: iconSize,
  },
});

Cuisines = withController(Cuisines, useCancellableRequest, 'api');

Cuisines.propTypes = {
  onPress: PropTypes.func.isRequired,
};

export default Cuisines;
